import { Box, Typography, Link } from "@mui/material";

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#c1c1c1",
        color: "#000",
        padding: "1.1rem 10%",
        mt: "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        {/* Left */}
        <Typography variant="body2">
          © {new Date().getFullYear()} PredPPI-GReMLIN <br />
          LaBio Laboratory of Bioinformatics, Visualization and Systems
        </Typography>

        <Box
          component="img"
          src="/image/ufv.png"
          alt="Description"
          sx={{ width: "7%"}}
        /> 

        {/* Right */}
        <Box sx={{ display: "flex", gap: 2 }}>
          {/* <Link href="/about" color="inherit" underline="hover">
            About
          </Link> */}
          <Link href="/contact" color="inherit" underline="hover">
            Contact
          </Link>
          <Link href="/services" color="inherit" underline="hover">
            Help
          </Link>
        </Box>
      </Box>
    </Box>
  );
}
